/**
 * Renaming the website or portal address (docs/Decisions.md D56 item 3,
 * D60 item 4). Mirrors src/services/domains/hostRules.js; the API decides.
 */

export const RENAME_WARNING =
  'Renaming an address can take it offline for 1 to 12 hours. The new address works only once ' +
  'its certificate is issued and your DNS change has spread, and the old address stops working ' +
  'as soon as the new one is live, so links and bookmarks to it break.';

export const ROLE_LABELS = { website: 'Website', portal: 'Portal' };

/** The creator is the first member; anyone beyond them means it must be scheduled. */
export function renameNeedsSchedule(memberCount) {
  return Number(memberCount) > 1;
}

const pad = n => String(n).padStart(2, '0');

/** A Date as a datetime-local input value, in the viewer's time zone. */
export function toLocalInput(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

/** The earliest a rename can be scheduled: an hour from now, to the next minute. */
export function earliestSchedule(now = new Date()) {
  const at = new Date(now.getTime() + 61 * 60 * 1000);
  at.setSeconds(0, 0);
  return at;
}

/** A datetime-local value as an ISO timestamp, or null. */
export function localInputToIso(value) {
  if (!value) return null;
  const at = new Date(value);
  return Number.isFinite(at.getTime()) ? at.toISOString() : null;
}
